import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FooterCorp from "../modulos/footerCorp";
import CadetesParaFranco from "./CadetesParaFranco";
import axios from "axios";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import Swal from "sweetalert2";
import CadetesBuscadorPresente from "../NCadetes/CadetesBuscadorPresentes";
import socket from "../tools/socke";
import PasesDeSalida from "../NCadetes/PasesDeSalida";
import GuardiaComponent from "./GuardiaComponent";
import DevuelveAvisos from "../Cuerpo/DevuelveAvisos";
import AvisosInternosPorFecha from "../NCadetes/AvisosInternosPorFecha";
import "./FrancosManager.css";

const GuardiaPrevencion = () => {
    const [visible, setvisible] = useState(false);
    const [porSecciones, setPorSecciones] = useState(false);
    const [porIndividuo, setPorIndividuo] = useState(false);
    const [porGuardiaSaliente, setporGuardiaSaliente] = useState(false);

    const [guardiaSaliente, setGuardiaSaliente] = useState([]);

    const [secciones, setSecciones] = useState([]);
    const [compañias, setCompanias] = useState([]);

    const [menuAbierto, setMenuAbierto] = useState(false);

    const navigate = useNavigate();

    const Usuario = ObtieneDatosCookies();

    // ============================================================
    // VOLVER
    // ============================================================

    const volver = () => {
        navigate("/usuarioLogueado");
    };

    // ============================================================
    // TRAER GUARDIA SALIENTE
    // ============================================================

    const traigoGuardiaSaliente = async () => {
        const token = btoa(
            `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
        );

        const client = axios.create({
            baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/devuelvePresentesGuardiaAyer`,
            headers: {
                Authorization: `Basic ${token}`,
            },
        });

        try {
            const response = await client.post("/");

            if (response.data) {
                setGuardiaSaliente(response.data);
            }
        } catch (error) {
            console.error(
                "Error al traer guardia saliente:",
                error
            );
        }
    };

    // ============================================================
    // DAR FRANCO POR COMPAÑÍA / PROMOCIÓN
    // ============================================================

    const construirInformeFrancoHTML = (informe = {}) => {
        const listaGuardia = Array.isArray(informe?.dnisConGuardia)
            ? informe.dnisConGuardia
            : [];

        const listaFranco = Array.isArray(informe?.dnisConFranco)
            ? informe.dnisConFranco
            : [];

        const errores = Array.isArray(informe?.errores)
            ? informe.errores
            : [];

        return `
            <div style="text-align:left; margin-top:15px; line-height:1.65;">
                <div style="background:#f5f5f5; padding:14px; border-radius:8px;">
                    <div><b>Sede:</b> ${informe?.sede ?? "-"}</div>
                    <div><b>Compañía:</b> ${informe?.companiaId ?? "-"}</div>
                    <div><b>Promoción:</b> ${informe?.promocionId ?? "-"}</div>

                    <hr style="border:none; border-top:1px solid #ddd; margin:12px 0;" />

                    <div><b>Cadetes del grupo:</b> ${informe?.cadetesDelGrupo ?? 0}</div>
                    <div><b>Presentes únicos:</b> ${informe?.presentesUnicos ?? 0}</div>
                    <div><b>Marcas activas:</b> ${informe?.marcasActivas ?? 0}</div>
                    <div><b>Guardias activas:</b> ${informe?.guardiasActivas ?? 0}</div>
                    <div><b>Disponibles para franco:</b> ${informe?.disponiblesParaFranco ?? 0}</div>

                    ${
                        informe?.asistenciasDesactivadas !== undefined
                            ? `
                                <hr style="border:none; border-top:1px solid #ddd; margin:12px 0;" />
                                <div><b>Asistencias desactivadas:</b> ${informe?.asistenciasDesactivadas ?? 0}</div>
                                <div><b>Duplicadas eliminadas:</b> ${informe?.duplicadasEliminadas ?? 0}</div>
                                <div><b>Errores al desactivar:</b> ${informe?.erroresDesactivando ?? 0}</div>
                              `
                            : ""
                    }

                    ${
                        listaGuardia.length > 0
                            ? `
                                <hr style="border:none; border-top:1px solid #ddd; margin:12px 0;" />
                                <details>
                                    <summary style="cursor:pointer;"><b>DNIs con guardia (${listaGuardia.length})</b></summary>
                                    <div style="margin-top:8px; max-height:120px; overflow:auto; word-break:break-word; font-size:12px;">
                                        ${listaGuardia.join("; ")}
                                    </div>
                                </details>
                              `
                            : ""
                    }

                    ${
                        listaFranco.length > 0
                            ? `
                                <details style="margin-top:8px;">
                                    <summary style="cursor:pointer;"><b>DNIs incluidos en franco (${listaFranco.length})</b></summary>
                                    <div style="margin-top:8px; max-height:120px; overflow:auto; word-break:break-word; font-size:12px;">
                                        ${listaFranco.join("; ")}
                                    </div>
                                </details>
                              `
                            : ""
                    }

                    ${
                        errores.length > 0
                            ? `
                                <details style="margin-top:8px;">
                                    <summary style="cursor:pointer; color:#c62828;"><b>Errores (${errores.length})</b></summary>
                                    <div style="margin-top:8px; max-height:140px; overflow:auto; font-size:12px;">
                                        ${errores
                                            .map(
                                                (item) =>
                                                    `<div>DNI ${item?.cadeteDni ?? "-"} - asistencia ${item?.asistenciaId ?? "-"}: ${item?.error ?? "Error"}</div>`
                                            )
                                            .join("")}
                                    </div>
                                </details>
                              `
                            : ""
                    }
                </div>
            </div>
        `;
    };

    const doyFrancoPorCompaniaPromocion = async (
        companiaId,
        promocionId,
        sedeTal
    ) => {
        const token = btoa(
            `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
        );

        const client = axios.create({
            baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/creaFrancoPorCompaniaPromocion`,
            headers: {
                Authorization: `Basic ${token}`,
            },
        });

        const confirmacion = await Swal.fire({
            title: "¿Estás seguro?",
            html: `
                <div style="text-align:left; line-height:1.6">
                    <p>Esta acción dará franco a la promoción y compañía seleccionada.</p>
                    <p>Sede: <b>${sedeTal}</b></p>
                    <p style="color:#c62828;">Esta acción no podrá deshacerse.</p>
                </div>
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, dar franco",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacion.isConfirmed) {
            return;
        }

        try {
            const sedeID = Number(Usuario?.sedeID);
            const destino = Number(Usuario?.destino);

            let sedePasada = "";

            if (sedeID == 1 || destino == 7) {
                sedePasada = sedeTal;
            } else if (sedeID == 2) {
                sedePasada = "Rosario";
            } else if (sedeID == 3) {
                sedePasada = "Recreo";
            } else {
                await Swal.fire({
                    title: "No se pudo determinar la sede",
                    text: "El usuario no posee una sede válida para realizar esta operación.",
                    icon: "error",
                });
                return;
            }

            const datos = {
                usuarioId: Usuario.id,
                sede: sedePasada,
                companiaId,
                promocionId,
            };
console.log("Datos enviados para dar franco:", datos);
            const response = await client.post("/", datos);

            const informe = response.data?.informe || {};
            const detalleInforme = construirInformeFrancoHTML(informe);

            if (response.data?.success) {
                await Swal.fire({
                    title: "Franco otorgado",
                    html: `
                        <p>${response.data?.message || "Se ha dado franco correctamente."}</p>
                        ${detalleInforme}
                        <p style="margin-top:15px; font-size:13px; color:#666;">
                            Tenga en cuenta que esta acción no puede deshacerse.
                        </p>
                    `,
                    icon: "success",
                    width: 700,
                    confirmButtonText: "Aceptar",
                });

                socket.emit(
                    "creaPresenteCadete",
                    "Cambia Presente"
                );

                setPorIndividuo(false);
                traigoGuardiaSaliente();
            } else {
                await Swal.fire({
                    title: "No se pudo dar franco",
                    html: `
                        <p>${
                            response.data?.message ||
                            "No se pudo generar el franco."
                        }</p>
                        ${detalleInforme}
                    `,
                    icon: "warning",
                    width: 700,
                    confirmButtonText: "Aceptar",
                });
            }
        } catch (error) {
            const dataError = error?.response?.data || {};
            const informe = dataError?.informe || {};
            const detalleInforme = construirInformeFrancoHTML(informe);

            await Swal.fire({
                title: "Error al generar el franco",
                html: `
                    <p>${
                        dataError?.message ||
                        error?.message ||
                        "Ocurrió un error al procesar la solicitud."
                    }</p>
                    ${detalleInforme}
                    ${
                        dataError?.error
                            ? `<div style="margin-top:12px; font-size:12px; color:#b71c1c; word-break:break-word;"><b>Detalle:</b> ${dataError.error}</div>`
                            : ""
                    }
                `,
                icon: "error",
                width: 700,
                confirmButtonText: "Aceptar",
            });
        }
    };

    // ============================================================
    // COMPLETAR FRANCO INDIVIDUAL
    // ============================================================

    const completoElFrancoIndividual = async (
        info
    ) => {
        const token = btoa(
            `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
        );

        const client = axios.create({
            baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/creaFrancoPorCadete`,

            headers: {
                Authorization:
                    `Basic ${token}`,
            },
        });

        try {

            const datos = {

                cadeteDni:
                    info.cadeteDni,

                usuarioId:
                    Usuario.id,

                sede:
                    info.cadeteSede,

                seccionId:
                    "2",
            };

            const response =
                await client.post(
                    "/",
                    datos
                );

            if (
                response.data.success
            ) {

                socket.emit(
                    "creaPresenteCadete",
                    []
                );

                Swal.fire(
                    "Franco otorgado",
                    `Se ha dado franco al cadete ${info.cadeteApellido}. Tenga en cuenta que esta acción no puede deshacerse.`,
                    "success"
                );

                setPorIndividuo(
                    false
                );

            } else {

                Swal.fire(
                    "No se pudo dar franco",
                    response.data.message ||
                        "El cadete no está presente en el instituto.",
                    "error"
                );
            }

        } catch (error) {

            console.error(
                "Error al dar franco individual:",
                error
            );

            Swal.fire(
                "Error",
                "Ocurrió un error al procesar el franco individual.",
                "error"
            );
        }
    };

    // ============================================================
    // CONFIRMAR FRANCO INDIVIDUAL
    // ============================================================

    const doyFranco = async (
        info
    ) => {

        Swal.fire({
            title:
                "Está por darle franco al cadete: " +
                info.cadeteApellido +
                ". ¿Desea continuar?",

            text:
                "Esta acción no puede deshacerse.",

            icon:
                "warning",

            showCancelButton:
                true,

            confirmButtonText:
                "Sí, continuar",

            cancelButtonText:
                "Cancelar",

        }).then(
            (result) => {

                if (
                    result.isConfirmed
                ) {

                    completoElFrancoIndividual(
                        info
                    );

                } else if (
                    result.dismiss ===
                    Swal.DismissReason
                        .cancel
                ) {

                    Swal.fire(
                        "Acción cancelada",
                        "No se ha realizado ningún cambio.",
                        "error"
                    );
                }
            }
        );
    };

    // ============================================================
    // REFRESCAR
    // ============================================================

    const refresca = (
        sa
    ) => {

        socket.emit(
            "creaPresenteCadete",
            "Cambia Presente"
        );

        traigoGuardiaSaliente();
    };

    // ============================================================
    // OBTENER SECCIONES
    // ============================================================

    const obtenerSecciones = async () => {

        try {

            const response = null;

            const seccionesData =
                response?.data ||
                [];

            setSecciones(
                seccionesData
            );

            const companiasAgrupadas =
                seccionesData.reduce(
                    (
                        acc,
                        seccion
                    ) => {

                        const {
                            nombre,
                        } =
                            seccion.Compania;

                        if (
                            !acc[
                                nombre
                            ]
                        ) {

                            acc[
                                nombre
                            ] = [];
                        }

                        acc[
                            nombre
                        ].push(
                            seccion
                        );

                        return acc;
                    },
                    {}
                );

            setCompanias(
                Object.keys(
                    companiasAgrupadas
                )
            );

        } catch (error) {

            console.error(
                "Error al obtener las secciones",
                error
            );
        }
    };

    // ============================================================
    // USE EFFECT
    // ============================================================

    useEffect(() => {

        traigoGuardiaSaliente();

        obtenerSecciones();

    }, []);

    // ============================================================
    // VARIABLES DE PERMISOS POR SEDE
    // ============================================================

    const sedeUsuario =
        Number(
            Usuario?.sedeID
        );

    const destinoUsuario =
        Number(
            Usuario?.destino
        );

    // sedeID 1 = ambas
    // sedeID 2 = Rosario
    // destino 7 = ambas

    const puedeVerRosario =
        sedeUsuario == 1 ||
        sedeUsuario == 2 ||
        destinoUsuario == 7;

    // sedeID 1 = ambas
    // sedeID 3 = Recreo
    // destino 7 = ambas

    const puedeVerRecreo =
        sedeUsuario == 1 ||
        sedeUsuario == 3 ||
        destinoUsuario == 7;

    // ============================================================
    // RENDER
    // ============================================================

    return (

        <div className="gp-page-layout">

            {/* ================================================= */}
            {/* BARRA SUPERIOR                                    */}
            {/* ================================================= */}

            <header className="gp-topbar">

                <button
                    type="button"

                    className={`gp-hamburger ${
                        menuAbierto
                            ? "is-active"
                            : ""
                    }`}

                    onClick={() =>
                        setMenuAbierto(
                            !menuAbierto
                        )
                    }

                    aria-label="Toggle Navigation"
                >

                    <span className="gp-hamburger__bar" />

                    <span className="gp-hamburger__bar" />

                    <span className="gp-hamburger__bar" />

                </button>

                <nav
                    className={`gp-nav-menu ${
                        menuAbierto
                            ? "gp-nav-menu--open"
                            : ""
                    }`}
                >

                    {/* FRANCOS POR COMPAÑÍA */}

                    <button
                        type="button"

                        className={`gp-nav__item ${
                            porSecciones
                                ? "gp-nav__item--active"
                                : ""
                        }`}

                        onClick={() => {

                            setPorSecciones(
                                !porSecciones
                            );

                            setporGuardiaSaliente(
                                false
                            );

                            setPorIndividuo(
                                false
                            );

                            traigoGuardiaSaliente();

                            setMenuAbierto(
                                false
                            );
                        }}
                    >

                        📊 Francos por Compañía y Promoción

                    </button>

                    {/* GUARDIA SALIENTE */}

                    <button
                        type="button"

                        className={`gp-nav__item ${
                            porGuardiaSaliente
                                ? "gp-nav__item--active"
                                : ""
                        }`}

                        onClick={() => {

                            setporGuardiaSaliente(
                                !porGuardiaSaliente
                            );

                            setPorSecciones(
                                false
                            );

                            setPorIndividuo(
                                false
                            );

                            setMenuAbierto(
                                false
                            );
                        }}
                    >

                        🛡️ Francos Guardia Saliente

                    </button>

                    {/* INDIVIDUALES */}

                    <button
                        type="button"

                        className={`gp-nav__item ${
                            porIndividuo
                                ? "gp-nav__item--active"
                                : ""
                        }`}

                        onClick={() => {

                            setPorIndividuo(
                                !porIndividuo
                            );

                            setPorSecciones(
                                false
                            );

                            setporGuardiaSaliente(
                                false
                            );

                            setMenuAbierto(
                                false
                            );
                        }}
                    >

                        👤 Francos Individuales

                    </button>

                    {/* VOLVER */}

                    <button
                        type="button"

                        className="gp-nav__item gp-nav__item--volver"

                        onClick={
                            volver
                        }
                    >

                        ← Volver

                    </button>

                </nav>

            </header>

            {/* ================================================= */}
            {/* CONTENIDO PRINCIPAL                               */}
            {/* ================================================= */}

            <main className="gp-main-content">

                {/* ================================================= */}
                {/* ENCABEZADO                                        */}
                {/* ================================================= */}

                <div className="gp-header-banner">

                    <span className="gp-header-banner__eyebrow">
                        GESTIÓN DE GUARDIA · ISeP
                    </span>

                    <h1 className="gp-header-banner__title">
                        Guardia de Prevención
                    </h1>

                    <p className="gp-header-banner__subtitle">
                        Módulo de control de francos,
                        pases de salida y servicios de guardia.
                    </p>

                </div>

                {/* ================================================= */}
                {/* ÁREA DE FRANCOS                                   */}
                {/* ================================================= */}

                {(
                    porSecciones ||
                    porGuardiaSaliente ||
                    porIndividuo
                ) && (

                    <div className="gp-card gp-card--francos">

                        <div className="gp-card__header">

                            <h3 className="gp-card__title">
                                Área de Francos
                            </h3>

                        </div>

                        <div className="gp-card__body">

                            {/* ===================================== */}
                            {/* FRANCO POR COMPAÑÍA                    */}
                            {/* ===================================== */}

                            {porSecciones && (

                                <div className="francos-content">

                                    {/* ================================= */}
                                    {/* SIN COMPAÑÍA / DESTINO 7           */}
                                    {/* ================================= */}

                                    {destinoUsuario === 7 && (

                                        <div className="compania-card sin-compania">

                                            <h4 className="compania-card__title">
                                                Cadetes Sin Compañía
                                            </h4>

                                            <div className="compania-card__actions">

                                                <button
                                                    type="button"

                                                    className="btn-opcion btn-opcion--primary"

                                                    onClick={() =>
                                                        doyFrancoPorCompaniaPromocion(
                                                            1,
                                                            4,
                                                            "Rosario"
                                                        )
                                                    }
                                                >

                                                    Rosario

                                                </button>

                                                <button
                                                    type="button"

                                                    className="btn-opcion btn-opcion--secondary"

                                                    onClick={() =>
                                                        doyFrancoPorCompaniaPromocion(
                                                            1,
                                                            4,
                                                            "Recreo"
                                                        )
                                                    }
                                                >

                                                    Recreo

                                                </button>

                                            </div>

                                        </div>
                                    )}

                                    {/* ================================= */}
                                    {/* ROSARIO                            */}
                                    {/* ================================= */}

                                    {puedeVerRosario && (

                                        <div className="sede-group">

                                            <h3 className="sede-group__title">
                                                Sede Rosario
                                            </h3>

                                            <div className="companias-grid">

                                                {[
                                                    {
                                                        id: 2,
                                                        name:
                                                            "Primer Compañía",
                                                        segAnno:
                                                            2,
                                                        primAnno:
                                                            4,
                                                    },
                                                    {
                                                        id: 3,
                                                        name:
                                                            "Segunda Compañía",
                                                        segAnno:
                                                            2,
                                                        primAnno:
                                                            4,
                                                    },
                                                    {
                                                        id: 4,
                                                        name:
                                                            "Tercer Compañía",
                                                        segAnno:
                                                            2,
                                                        primAnno:
                                                            4,
                                                    },
                                                ].map(
                                                    (
                                                        comp
                                                    ) => (

                                                        <div
                                                            key={
                                                                comp.id
                                                            }

                                                            className="compania-card compania-card--dark"
                                                        >

                                                            <h4 className="compania-card__title">

                                                                {
                                                                    comp.name
                                                                }

                                                            </h4>

                                                            <div className="compania-card__actions">

                                                                <button
                                                                    type="button"

                                                                    className="btn-opcion btn-opcion--warning"

                                                                    onClick={() =>
                                                                        doyFrancoPorCompaniaPromocion(
                                                                            comp.id,
                                                                            comp.segAnno,
                                                                            "Rosario"
                                                                        )
                                                                    }
                                                                >

                                                                    Segundo Año

                                                                </button>

                                                                <button
                                                                    type="button"

                                                                    className="btn-opcion btn-opcion--success"

                                                                    onClick={() =>
                                                                        doyFrancoPorCompaniaPromocion(
                                                                            comp.id,
                                                                            comp.primAnno,
                                                                            "Rosario"
                                                                        )
                                                                    }
                                                                >

                                                                    Primer Año

                                                                </button>

                                                            </div>

                                                        </div>
                                                    )
                                                )}

                                            </div>

                                        </div>
                                    )}

                                    {/* ================================= */}
                                    {/* RECREO                             */}
                                    {/* ================================= */}

                                    {puedeVerRecreo && (

                                        <div className="sede-group">

                                            <h3 className="sede-group__title">
                                                Sede Recreo
                                            </h3>

                                            <div className="companias-grid">

                                                {[
                                                    {
                                                        id: 6,
                                                        name:
                                                            "Primer Compañía",
                                                        colorClass:
                                                            "text-green",
                                                    },
                                                    {
                                                        id: 7,
                                                        name:
                                                            "Segunda Compañía",
                                                        colorClass:
                                                            "text-red",
                                                    },
                                                    {
                                                        id: 8,
                                                        name:
                                                            "Tercer Compañía",
                                                        colorClass:
                                                            "text-purple",
                                                    },
                                                ].map(
                                                    (
                                                        comp
                                                    ) => (

                                                        <div
                                                            key={
                                                                comp.id
                                                            }

                                                            className="compania-card"
                                                        >

                                                            <h4
                                                                className={`compania-card__title ${comp.colorClass}`}
                                                            >

                                                                {
                                                                    comp.name
                                                                }

                                                            </h4>

                                                            <div className="compania-card__actions">

                                                                <button
                                                                    type="button"

                                                                    className="btn-opcion btn-opcion--warning"

                                                                    onClick={() =>
                                                                        doyFrancoPorCompaniaPromocion(
                                                                            comp.id,
                                                                            2,
                                                                            "Recreo"
                                                                        )
                                                                    }
                                                                >

                                                                    Segundo Año

                                                                </button>

                                                                <button
                                                                    type="button"

                                                                    className="btn-opcion btn-opcion--success"

                                                                    onClick={() =>
                                                                        doyFrancoPorCompaniaPromocion(
                                                                            comp.id,
                                                                            4,
                                                                            "Recreo"
                                                                        )
                                                                    }
                                                                >

                                                                    Primer Año

                                                                </button>

                                                            </div>

                                                        </div>
                                                    )
                                                )}

                                            </div>

                                        </div>
                                    )}

                                </div>
                            )}

                            {/* ===================================== */}
                            {/* GUARDIA SALIENTE                      */}
                            {/* ===================================== */}

                            {porGuardiaSaliente &&
                                guardiaSaliente && (

                                    <div className="francos-panel">

                                        <CadetesParaFranco
                                            datosCadetes={
                                                guardiaSaliente
                                            }

                                            tipo={
                                                1
                                            }

                                            finalizo={(
                                                a
                                            ) =>
                                                refresca(
                                                    a
                                                )
                                            }
                                        />

                                    </div>
                                )}

                            {/* ===================================== */}
                            {/* FRANCO INDIVIDUAL                      */}
                            {/* ===================================== */}

                            {porIndividuo && (

                                <div className="francos-panel">

                                    <CadetesBuscadorPresente
                                        devuelvo={(
                                            a
                                        ) =>
                                            doyFranco(
                                                a
                                            )
                                        }
                                    />

                                </div>
                            )}

                        </div>

                    </div>
                )}

                {/* ================================================= */}
                {/* PASES DE SALIDA                                   */}
                {/* ================================================= */}

                <div className="gp-card gp-card--pases">

                    <div className="gp-card__body">

                        <PasesDeSalida />

                    </div>

                </div>

                {/* ================================================= */}
                {/* GUARDIA Y AVISOS                                  */}
                {/* ================================================= */}

                <div className="gp-card gp-card--guardia">

                    <div className="gp-card__body">

                        {/* ========================================= */}
                        {/* SEDE ID 1 → LAS DOS SEDES                 */}
                        {/* ========================================= */}

                        {sedeUsuario === 1 ? (

                            <>

                                <GuardiaComponent
                                    sede="Rosario"
                                />

                                <GuardiaComponent
                                    sede="Recreo"
                                />

                                <div className="gp-avisos-wrapper">

                                    <AvisosInternosPorFecha
                                        sede="Rosario"
                                    />

                                    <AvisosInternosPorFecha
                                        sede="Recreo"
                                    />

                                </div>

                                <div className="gp-avisos-box">

                                    <DevuelveAvisos
                                        sede="Rosario"
                                    />

                                    <DevuelveAvisos
                                        sede="Recreo"
                                    />

                                </div>

                            </>

                        ) : sedeUsuario === 2 ? (

                            /* ===================================== */
                            /* ROSARIO                               */
                            /* ===================================== */

                            <>

                                <GuardiaComponent
                                    sede="Rosario"
                                />

                                <div className="gp-avisos-wrapper">

                                    <AvisosInternosPorFecha
                                        sede="Rosario"
                                    />

                                </div>

                                <div className="gp-avisos-box">

                                    <DevuelveAvisos
                                        sede="Rosario"
                                    />

                                </div>

                            </>

                        ) : (

                            /* ===================================== */
                            /* RECREO                                */
                            /* ===================================== */

                            <>

                                <GuardiaComponent
                                    sede="Recreo"
                                />

                                <div className="gp-avisos-wrapper">

                                    <AvisosInternosPorFecha
                                        sede="Recreo"
                                    />

                                </div>

                                <div className="gp-avisos-box">

                                    <DevuelveAvisos
                                        sede="Recreo"
                                    />

                                </div>

                            </>
                        )}

                    </div>

                </div>

                {/* ================================================= */}
                {/* PRÓXIMA GUARDIA                                   */}
                {/* ================================================= */}

                {visible && (

                    <div className="gp-card gp-card--proxima-guardia">

                        <p>
                            Próxima Guardia
                        </p>

                    </div>
                )}

            </main>

            {/* ================================================= */}
            {/* FOOTER                                            */}
            {/* ================================================= */}

            <footer className="gp-footer">

                <FooterCorp />

            </footer>

        </div>
    );
};

export default GuardiaPrevencion;